export const quoteStyle = {
  container: provided => ({
    ...provided,
    marginRight: '5px',
    width: "100%",
    border: "1px solid indigo",
    bg:"#F3F5FF",
    height:"3rem",
    borderRadius:"5px"
  }),
  indicatorSeparator: () => ({
    display:'none'
  }),
  valueContainer: provided => ({
    ...provided,
    marginRight: '5px',
    width: "100%",
  }),
  singleValue: provided => ({
    ...provided,
    overflow: "none"
  }),
  control: (provided) => {
    return {
      ...provided,
      width: "100%",
      border: 0,
      boxShadow: 'none',
    };
  },
  option: (provided) => {
    return {
      ...provided,
      paddingRight: '20px',
      height: '2.5rem',
      fontSize: "14px",
    };
  },
  placeholder: (provided) => {
    return {
      ...provided,
      color: '#A0A3BD'
    };
  }
};
